import { FormGroup } from "./FormGroup"
import { classes } from "./react"

interface cssStyleObject {
    width?: string
    paddingLeft?: string
    paddingTop?: string
    paddingBottom?: string
    border?: string
    outline?: string
    align?: string
}

interface TextInputProps {
    value?: string | readonly string[] | undefined
    setValue?: (v: string) => void
    placeholder?: string
    className?: string
    readOnly?: boolean
    disabled?: boolean
    required?: boolean
    maxLength?: number
    cssStyle?: cssStyleObject
    align?: string
    autoComplete?: string
}

export function TextInput({
    value,
    setValue,
    placeholder,
    className,
    readOnly,
    disabled,
    required,
    maxLength,
    cssStyle,
    align = "left",
    autoComplete
}: TextInputProps) {

    let style = cssStyle ?? {}
    style.align = align

    return (
        <input
            type="text"
            value={value}
            placeholder={placeholder}
            className={classes("form-control", className)}
            onChange={(e) => setValue?.(e.target.value)}
            readOnly={readOnly}
            required={required}
            maxLength={maxLength}
            style={cssStyle}
            disabled={disabled}
            autoComplete={autoComplete}
        />
    )
}

export function FormGroupTextInput(
    props: TextInputProps & { label?: React.ReactNode; invalid?: boolean | string }
) {
    const { className, label, invalid, ...inputProps } = props
    return (
        <FormGroup label={label} className={className} invalid={invalid}>
            <TextInput {...inputProps} />
        </FormGroup>
    )
}

export function TextArea({
    value,
    setValue,
    placeholder,
    className,
    readOnly,
    required,
    rows,
    maxRows,
    style,
    autoComplete
}: TextInputProps & { rows?: number, maxRows?: number, style?: React.CSSProperties }) {

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const inputValue = e.target.value;
        if (maxRows === undefined || maxRows === null) {
            setValue?.(e.target.value);
        } 
        else {
            const lines = inputValue?.split('\n') ?? [];
            const lineCount = lines.length;
            if (lineCount <= maxRows) {
                setValue?.(inputValue);
            }
        }
    }

    return (
        <textarea
            value={value}
            placeholder={placeholder}
            className={classes("form-control", className)}
            onChange={handleChange}
            readOnly={readOnly}
            required={required}
            rows={rows ?? 4}
            style={style}
            autoComplete={autoComplete}
        />
    )
}

export function FormGroupTextArea(
    props: TextInputProps & { label?: React.ReactNode; rows?: number; maxRows?: number }
) {
    const { className, label, ...areaProps } = props
    return (
        <FormGroup label={label} className={className}>
            <TextArea {...areaProps} />
        </FormGroup>
    )
}
